import { IMenuItem } from '../models/account.model';


export const ACCOUNT_SIDE_BAR_MENU_QA_LOCATOR = {
  businessProfile : 'business-profile',
  businessAddresses : 'address-book',
  personalProfile : 'personal-profile',
  personalAddresses : 'address-book-personal',
};

export const ACCOUNT_MENU_ITEM_LIST: IMenuItem[] = [
  {
    text: 'PAGES.ACCOUNT.INFO.TITLE',
    iconName: 'user-bold',
    link: './info',
    qaTargetName: 'info',
  },
  {
    text: 'PAGES.ACCOUNT.ADDRESS_BOOK.TITLE',
    iconName: 'map-target-bold',
    link: './address-book',
    qaTargetName: ACCOUNT_SIDE_BAR_MENU_QA_LOCATOR.businessAddresses,
  },
  {
    text: 'PAGES.ACCOUNT.ORDERS_HISTORY.TITLE',
    iconName: 'box',
    link: './orders-history',
    qaTargetName: 'orders-history',
  },
];

export const ACCOUNT_MENU_GA_EVENT_LABEL = {
    support : 'support',
    logout : 'logout',
    businessProfile : 'businessProfile',
    businessAddresses : 'businessAddresses',
    personalProfile : 'profile',
    personalAddresses : 'personalAddresses',
    staffAndPermissions : 'staffAndPermissions',
    metroMail : 'metroMail',
    promotionalFlyers : 'promotionalFlyers',
    digitalPurchaseAuthorization : 'limitedShoppingPermission',
    newslettersAndPromotions: 'newslettersAndPromotions',
    loginAndSecurity : 'loginAndSecurity',
    personalOrderHistory : 'metroMarketsPersonalPurchases',
    businessOrderHistory : 'metroMarketsBusinessPurchases',
    storedPaymentMethod : 'storedPaymentMethod',
};

export const ORDER_HISTORY_MENU = {
  personal : 'metroMarkets',
  business : 'metroMarketsPurchases',
};

